import { Grid } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { FormSwitch } from 'redesign';
import { CompanySettingsData } from './settings-edit-page';

export const SettingsEdit = () => {
  const { control } = useFormContext<CompanySettingsData>();
  const { t } = useTranslation('ogp-screen-specific');
  return (
    <Grid container item spacing={2} xs={6}>
      <Grid item xs={12}>
        <FormSwitch
          name="requiresEmployeeContract"
          control={control}
          label={t('settings-edit-page.employee-contract-requested-label')}
        />
      </Grid>
    </Grid>
  );
};
